import React from "react";
import { Button, ModalBody, ModalFooter, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { ClasswizeModal } from "@/components/ui/Modal";

interface Props {
	isOpen: boolean;
	onClose: () => void;
	onConfirm: () => void;
	/** Held back while a save is still writing the layout this reset would delete. */
	isConfirmDisabled?: boolean;
}

export function ConfirmResetAutoSortModal(props: Props): JSX.Element {
	const { t } = useTranslation();

	return (
		<ClasswizeModal
			isOpen={props.isOpen}
			onClose={props.onClose}
			size="lg"
			title={t("seatPlan.resetToAutoSortConfirmTitle")}
			dataTestId="seatplan-reset-auto-sort-modal"
			closeButtonDataTestId="seatplan-reset-auto-sort-close-button"
		>
			<ModalBody>
				<Text>{t("seatPlan.resetToAutoSortConfirmBody")}</Text>
			</ModalBody>
			<ModalFooter gap={2}>
				<Button variant="ghost" onClick={props.onClose} data-testid="seatplan-reset-auto-sort-cancel">
					{t("seatPlan.cancel")}
				</Button>
				<Button
					onClick={() => {
						props.onConfirm();
						props.onClose();
					}}
					isDisabled={props.isConfirmDisabled}
					data-testid="seatplan-reset-auto-sort-confirm"
				>
					{t("seatPlan.resetToAutoSort")}
				</Button>
			</ModalFooter>
		</ClasswizeModal>
	);
}
